import p from './add';

export * from './add';
export default p;
